// ROOM 404: Supabase Free Tier Auth Only
// Dedicated strictly to Personal Email Magic-Link / OTP Authentication.
// Production builds FAIL configuration validation if valid Supabase variables are missing.

import { createClient } from '@supabase/supabase-js';

const isProduction = import.meta.env.PROD || import.meta.env.MODE === 'production';
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Mock auth is strictly prohibited in production and can ONLY be enabled in development via explicit flag
export const isDevMockAuthEnabled =
  !isProduction && import.meta.env.VITE_ENABLE_DEV_MOCK_AUTH === 'true';

// Validate configuration
if (!isDevMockAuthEnabled) {
  if (
    !supabaseUrl ||
    !supabaseAnonKey ||
    supabaseUrl.includes('demo-room404') ||
    supabaseUrl.includes('your-project') ||
    supabaseAnonKey.includes('dummy')
  ) {
    const errorMsg =
      'FATAL CONFIGURATION ERROR: Valid VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are required for authentication. Automatic fallback to fabricated credentials in production is strictly prohibited.';
    if (isProduction && typeof window !== 'undefined' && window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
      throw new Error(errorMsg);
    } else {
      console.warn(`[ROOM_404_CONFIG_WARNING] ${errorMsg}`);
    }
  }
}

// Supabase client instance strictly scoped to Auth
export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder_anon_key',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  }
);

export async function sendEmailOtp(email: string) {
  if (isDevMockAuthEnabled) {
    return { data: { user: null }, error: null, demoMode: true };
  }

  if (!supabaseUrl || !supabaseAnonKey) {
    return {
      data: null,
      error: new Error('Supabase authentication is not configured. Please supply VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY.'),
      demoMode: false,
    };
  }

  const { data, error } = await supabase.auth.signInWithOtp({
    email,
    options: {
      emailRedirectTo: window.location.origin,
    },
  });

  return { data, error, demoMode: false };
}

export async function verifyEmailOtp(email: string, token: string) {
  if (isDevMockAuthEnabled) {
    return {
      data: {
        session: {
          access_token: 'dev_mock_jwt_' + btoa(JSON.stringify({ sub: 'user_dev_1', email })),
          user: { id: 'user_dev_1', email },
        },
      },
      error: null,
    };
  }

  if (!supabaseUrl || !supabaseAnonKey) {
    return {
      data: null,
      error: new Error('Supabase authentication is not configured.'),
    };
  }

  const { data, error } = await supabase.auth.verifyOtp({
    email,
    token,
    type: 'email',
  });

  return { data, error };
}
